import React from 'react'
import Blogging from './Blogging'

const Blogs = () => {
  return (
    <div>
        <Blogging/>
    </div>
  )
}

export default Blogs
